// Mirrors ChannelWebpageGuard's reserved-keyword check (channel-webpage.guard.ts) so login
// redirect code can tell whether a /:channelName/... URL already has a real :groupName segment,
// without duplicating that guard's inline logic a third time.
const ORG_RESERVED_KEYWORDS = new Set([
  'signin', 'channelSearch', 'preview', 'sign-up', '404',
  'my-library', 'playlist', 'contactus', 'privacypolicy',
  'cookiepolicy', 'termsandconditions', 'subscription-list',
  'event', 'community', 'merchandise', 'album', 'album-video', 'channel', 'fastChannel',
  'user-dashboard', 'video', 'audio', 'recorded-video'
]);

// Returns the :groupName segment when the URL has a real one, '' otherwise (empty segment or a
// reserved keyword like "signin"/"sign-up" that channel-webpage.guard.ts never treats as a group).
export function getGroupSegment(url: string): string {
  const urlParts = (url || '').split('/');
  const potentialGroupSlug = urlParts[2] ? urlParts[2].split('?')[0] : '';
  return potentialGroupSlug && !ORG_RESERVED_KEYWORDS.has(potentialGroupSlug) ? potentialGroupSlug : '';
}

export function hasGroupSegment(url: string): boolean {
  return !!getGroupSegment(url);
}
